const importRouter = [
    {
        path: 'list-import',
        name: 'import',
        component: () => import('@/views/admin/import/index.vue'),
        meta: {
            model: 'import',
            requiresAuth: true,
        }
    },
    {
        path: 'list-import/boxs',
        name: 'importBoxs',
        component: () => import('@/views/admin/import/box/index'),
        meta: {
            model: 'record_detail',
            requiresAuth: true,
        }
    },
    {
        path: "list-import/add",
        name: "addImport",
        component: () => import("@/views/admin/import/function"),
        default: true,
        meta: {
            model: "import",
            // requiresAuth: true,
        },
    },
    {
        path: "list-import/view/:id",
        name: "viewImport",
        component: () => import("@/views/admin/import/function"),
        default: true,
        meta: {
            model: "import",
            // requiresAuth: true,
        },
    },
];

export default importRouter;